import React from 'react';
import { SearchBrand } from '../../../types/searchType';
import BrandBadgeIcon from '../../../assets/icons/icon_brand_badge.svg';
import './BrandsTab.css';
import BrandSearchSkeleton from './BrandSearchSkeleton';
import { useNavigate } from 'react-router-dom';

interface BrandsTabProps {
  searchQuery: string;
  brands: SearchBrand[];
  isLoading?: boolean;
}

const BrandsTab: React.FC<BrandsTabProps> = ({ 
  searchQuery, 
  brands,
  isLoading = false 
}) => {
  const navigate = useNavigate();

  const handleCollabClick = (collabPostSlug: string | null) => {
    if (collabPostSlug) {
      navigate(`/posts/${collabPostSlug}`);
    }
  };

  if (isLoading) {
    return (
      <div className="brands-tab">
        <BrandSearchSkeleton />
        <BrandSearchSkeleton />
        <BrandSearchSkeleton />
      </div>
    );
  }

  if (!brands.length) {
    return <div className="brands-tab">No brands found</div>;
  }

  return (
    <div className="brands-tab">
      <ul className="account-list">
        {brands.map((brand, index) => (
          <li key={index} className="account-item">
            <img 
              src={brand.profile_picture || '/path/to/default/brand/image.png'} 
              alt={brand.name || 'Brand'} 
              className="account-avatar" 
            />
            <span className="account-name">
              {brand.name}
              <img src={BrandBadgeIcon} alt="Brand" className="brand-badge" />
            </span>
            <button 
              className={`collabs-button ${brand.has_active_collab ? 'active' : ''}`}
              onClick={() => handleCollabClick(brand.collab_post_slug)}
              disabled={!brand.has_active_collab}
            >
              Collabs
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandsTab;
